module.exports = __webpack_public_path__ + "img/banner-tc3.e9369b8d.jpg";